import { render } from "./ActionDetails.vue?vue&type=template&id=ade236c6&scoped=true"
import script from "./ActionDetails.vue?vue&type=script&lang=js"
export * from "./ActionDetails.vue?vue&type=script&lang=js"

import "./ActionDetails.vue?vue&type=style&index=0&id=ade236c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade236c6"]])

export default __exports__